import axiosClient from './axiosClient'
const districtApi = {
  getAll: (params) => {
    const url = '/district/getAll'
    return axiosClient.get(url, { params })
  },
}
export default districtApi
